import { env } from '@shared/config/env';

/**
 * Static, app-wide constants. Values that depend on the environment are read
 * from the validated `env` object so there is a single configuration surface.
 */
export const APP = {
  NAME: env.appName,
  DEFAULT_PAGE_SIZE: 20,
  PAGE_SIZE_OPTIONS: [10, 20, 50, 100] as const,
  DEBOUNCE_MS: 300,
  TOAST_DURATION_MS: 4_000,
} as const;
